import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable()
export class MomentLocaleService {
    setLocaleFromBrowser() {
        moment.locale("pt-BR");
    }
}
